define([
  'common/util.element'
], function (el) {
  return function (onlyFavoritsPagination = false) {
    var moduleElement = document.querySelector(".favorites");

    if (moduleElement != null) {      
      var moduleElementMobile = moduleElement.querySelector(".favorites-icon-mobile");

      var containerFavorits = moduleElement.querySelector(".favorites-second");

      /* ==== initilização e alteração do conteudo de favoritos ===== */
      initializeCheckFavorits();

      if (onlyFavoritsPagination === true) {

        // inicializa a área de favoritos
        renderFavorits();

      } else {

        // inicializa a área de favoritos
        renderFavorits(); //Verificar

        // inicializa os eventos de toggle favoritos
        initMenu();

        //  Evento e função que podem ser disparados por qualquer elemento da tela para adicionar um favorito.
        window.addEventListener("UpdateFavorits", updateComponent);
      }
    }
    // função de callback do evento de atualização de favoritos
    // recebe um evento
    // let sentEvent = new window.Event("UpdateFavorits");
    // sentEvent.data = { "Id": "1", "Quartos": "2", "ValorVenda": "1000", "AdvertisementRealEstateType": "RealEstateType", "Banheiros": "2", "Garagem": "4", "Area": "800" }
    // window.dispatchEvent(sentEvent);

    function updateComponent(_event) {
      if (_event.data) {
        let _data = JSON.parse(_event.data);
        let indexInStorage = indexOfStorageFavorits(_data.Id);

        let arrData = getStorageFavorits();

        if (indexInStorage !== -1) {

          var _removed = arrData[indexInStorage];
          if (_removed != null) {
            var itemCheck = document.querySelector("#f_" + _removed.Id);
            if (itemCheck) {
              itemCheck.classList.remove("active");
            }
          }
          arrData.splice(indexInStorage, 1);

        } else {
          if (arrData === null) arrData = [];
          arrData.push(_data);
        }

        window.localStorage.setItem("anuncios-favoritos", JSON.stringify(arrData));
        renderFavorits();
      }
    }

    // procura por botões com a classe e adiciona neles o evento de adicionar ou remover itens dos favoritos
    // Ex. de como deve estar o código do link que favorita/retira o favorito.
    // <a class="btn-favoritar-call" id="f_@item.Id" data-info='{ "Id" : "@item.Id", "Title" : "@item.Title", "Banheiros" : "@item.Bathrooms", "Garagem": "@item.ParkingSpots", "ValorVenda": "@item.Value", "Quartos" : "@item.Bedrooms" }'><i aria-hidden="true" class="icon-heart-o"> </i></a>
    function initializeCheckFavorits() {
      var btnFavoritos = document.querySelectorAll(".btn-favoritar-call");
      if (btnFavoritos) {
        for (var i = 0; i < btnFavoritos.length; i++) {

          btnFavoritos[i].addEventListener("click", function (e) {
            e.preventDefault();
            sendUpdateFavoritesEventData(this.getAttribute("data-info"));
            return false;
          });

        }

      }

    }

    function sendUpdateFavoritesEventData(data) {
      let sentEvent = createNewEvent("UpdateFavorits");
      sentEvent.data = data;
      window.dispatchEvent(sentEvent);
    }

    // criar evento para cross
    function createNewEvent(eventName) {
      var event
      if (typeof (Event) === 'function') {
        event = new window.Event(eventName);
      } else {
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
      }
      return event;
    }

    // renderiza o componente de favoritos e os corações de favoritar que estejam disponiveis
    function renderFavorits() {

      var containerFavoritsItens = "";
      var _listaFavoritos = getStorageFavorits();

      if (_listaFavoritos !== null) {
        for (let i = 0; i < _listaFavoritos.length; i++) {
          let _data = _listaFavoritos[i];
          containerFavoritsItens += convertObjectToDom(_data);
          var itemCheck = document.querySelector("#f_" + _data.Id);
          if (itemCheck != null) {
            itemCheck.classList.add("btn-favoritar-call");
            itemCheck.classList.add("active");
          }
        }
      }

      _renderNumber(_listaFavoritos);

      if (containerFavoritsItens) {
        containerFavorits.innerHTML = containerFavoritsItens;
      } else {
        containerFavorits.innerHTML = defaultPlaceHolderElement();
      }
      setEvents();
    }

    function _renderNumber(favorites) {
      let size = favorites == null ? 0 : favorites.length;
      let html = size > 0 ? `(${size})` : '';
      moduleElementMobile.querySelector('.number').innerHTML = html;
    }

    function defaultPlaceHolderElement() {
      return `<div class="empty-favorite">
                  <div>
                    <p>Adicione aqui seus imóveis favoritos.<br />
                    Basta clicar no <i aria-hidden="true" class="icon-heart-o"></i> que<br />
                    automaticamente ele estará<br />
                    disponível aqui.</p>
                  </div>
              </div>`;
    }

    function setEvents() {
      const removeButtons = moduleElement.querySelectorAll(".remove-favorite");

      for (var i = 0; i < removeButtons.length; i++) {
        removeButtons[i].addEventListener('click', function (e) {
          sendUpdateFavoritesEventData(e.target.getAttribute("data-info"))
        });
      }
    }

    // convert o objeto em nó fisico e retorna ele
    function convertObjectToDom(_obj) {

      return `
        <div class="favorites-div-container" id="Favorito_${_obj.Id}">
          <a alt="Remover" data-info='{"Id": "${_obj.Id}" }' class="remove-favorite">X</a>
          <a class="primary-link" href="/anuncio/index/${_obj.Id}">
            <div class="favorites-div-img" style="background-image: url('${_obj.Imagem}')"></div>
            <div class="favorites-div-money"><label>${_obj.ValorVenda}</label></div>
            <div class="favorites-div-text"><label>${_obj.Title}</label></div>
            <div class="favorites-div-icon">
              <label>${_obj.Quartos} <span class="icon-bed"></span></label>
              <label>${_obj.Banheiros} <span class="icon-bath"></span></label>
              <label>${_obj.Garagem} <span class="icon-car"></span></label>
              <label>${_obj.Area ? _obj.Area + 'm²' : 'Não definido'} <span class="icon-arrows-v"></span></label>
            </div>
          </a>
        </div>
      `;
    }

    //  verifica o index do anúncio no array do local storage de favoritos
    function indexOfStorageFavorits(_index) {
      var _anunciosFavorits = getStorageFavorits();
      if (_anunciosFavorits != null) {
        for (var t = 0; t < _anunciosFavorits.length; t++) {
          if (_anunciosFavorits[t].Id === _index) {
            return t;
          }
        }

      }
      return -1;
    }

    // recupera um objeto array do local storage, caso não exista retorna null;
    function getStorageFavorits() {
      return window.localStorage.getItem("anuncios-favoritos") ? JSON.parse(window.localStorage.getItem("anuncios-favoritos")) : null;
    }
    /* ==== initilização e alteração do conteudo de favoritos ===== */

    function initMenu() {
      let favoriteIcon = moduleElement.querySelector(".favorites-icon-mobile");
      let iconCloses = moduleElement.querySelectorAll(".icon-close");

      /* Menu Favoritos */
      document.querySelector(".show-favorites").addEventListener("click", function () {
        tooglePanel();
      });

      /* Ícone Coração */
      favoriteIcon.addEventListener("click", function () {
        tooglePanel();
      });

      for (var j = 0; j < iconCloses.length; j++) {
        let iconClose = iconCloses[j];
        iconClose.addEventListener("click", function () {
          tooglePanel();
        })

      }

      function tooglePanel() {
        var _selfPanel = document.querySelector(".favorites");
        _selfPanel.classList.toggle("favorites-mobile-full");
        _selfPanel.classList.toggle("favorites-mobile-hide");
      }
    }

  }
})
